import { EllipsisIcon } from 'lucide-react'

export const OAuthNeutral = () => (
  <>
    <div className="mt-auto w-min rounded-full border-2 border-neutral-600 bg-neutral-50 p-6">
      <EllipsisIcon className="h-16 w-16 text-neutral-700" />
    </div>
    <span className="mt-6 text-lg text-neutral-900">Hold on!</span>
  </>
)
